module.exports = __webpack_public_path__ + "img/bg1.2c71018d.png";